// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Temporary extension to include missing tables until types are regenerated
export type ExtendedDatabase = Database & {
  public: Database['public'] & {
    Tables: Database['public']['Tables'] & {
      caterer_service_airports: {
        Row: {
          airport_id: string
          caterer_profile_id: string
          id: string
          created_at: string
        }
        Insert: {
          airport_id: string
          caterer_profile_id: string
          id?: string
          created_at?: string
        }
        Update: {
          airport_id?: string
          caterer_profile_id?: string
          id?: string
          created_at?: string
        }
        Relationships: []
      }
      order_item_snapshots: {
        Row: {
          id: string
          order_id: string
          version_number: number
          snapshot_status: string
          snapshot_items_total: number | null
          snapshot_service_fee: number | null
          snapshot_basket_notes: string | null
          items: any
          created_at: string
          quote_pdf_url: string | null
        }
        Insert: {
          id?: string
          order_id: string
          version_number: number
          snapshot_status: string
          snapshot_items_total?: number | null
          snapshot_service_fee?: number | null
          snapshot_basket_notes?: string | null
          items: any
          created_at?: string
          quote_pdf_url?: string | null
        }
        Update: {
          id?: string
          order_id?: string
          version_number?: number
          snapshot_status?: string
          snapshot_items_total?: number | null
          snapshot_service_fee?: number | null
          snapshot_basket_notes?: string | null
          items?: any
          created_at?: string
          quote_pdf_url?: string | null
        }
        Relationships: []
      }
      baskets: {
        Row: {
          id: string
          user_id: string
          caterer_profile_id: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          caterer_profile_id: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          caterer_profile_id?: string
          created_at?: string
          updated_at?: string
        }
        Relationships: []
      }
      basket_items: {
        Row: {
          id: string
          basket_id: string
          menu_item_id: string
          quantity: number
          notes: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          basket_id: string
          menu_item_id: string
          quantity?: number
          notes?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          basket_id?: string
          menu_item_id?: string
          quantity?: number
          notes?: string | null
          created_at?: string
          updated_at?: string
        }
        Relationships: []
      }
    }
  }
}

const SUPABASE_URL_DIRECT = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

/** In dev, requests go through the Vite proxy (`/supabase` → Supabase project) to avoid browser CORS. */
function resolveSupabaseUrl(): string {
  if (import.meta.env.DEV && typeof window !== "undefined") {
    return `${window.location.origin}/supabase`;
  }
  return SUPABASE_URL_DIRECT;
}

const SUPABASE_URL = resolveSupabaseUrl();

if (!SUPABASE_URL_DIRECT || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error("Missing Supabase environment variables: VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set");
}

// Vite SPA: localStorage is appropriate (no SSR → no need for @supabase/ssr).
// flowType pkce: aligned with modern auth redirects (magic link may send ?code=).
export const supabase = createClient<ExtendedDatabase>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "pkce",
    detectSessionInUrl: true,
  },
});
